import { Rooms } from '@search/filter-enums/enums/Rooms';
import { ISearchType } from '@search/offer-search-routes/src';

export function offerSearchTextRoomType(
    {
        rooms
    }: {
        rooms?: ISearchType['rooms'];
    }
) {
    const roomType = rooms && rooms.length === 1 ? rooms[0] : undefined;

    switch (roomType) {
        case Rooms.OPEN_PLAN:
            return 'со свободной планировкой';
        case Rooms.ROOM_1:
            return '1-комнатную';
        case Rooms.ROOM_2:
            return '2-комнатную';
        case Rooms.ROOM_3:
            return '3-комнатную';
        case Rooms.ROOM_4:
            return '4-комнатную';
        case Rooms.ROOM_5_AND_MORE:
            return 'многокомнатную';
        case Rooms.STUDIO:
            return 'студию';
        default:
            return '';
    }
}
